module.exports = __webpack_public_path__ + "img/event4.411e3ab0.png";